import CustomFilterSelect from "./CustomFilterSelect";
const FilterAmountOffered = (props: any) => {
  const AmountFilterData = [
    { id: "1", name: "<$1000" },
    { id: "2", name: "$1000-$5000" },
    { id: "3", name: "$5000-$10,000" },
    { id: "4", name: "$10,000-$20,000" },
    { id: "5", name: ">$20,000" },
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      before={props?.before != null && props.before !== "" ? props.before : ""}
      source="amountReview"
      label="Amount Offered"
      choices={AmountFilterData}
    />
  );
};

export default FilterAmountOffered;
